import axios, { CancelToken } from "axios";
import { userLoaded, userLoading, userLoadingError } from "./userStateActions";
import apiUser from "./userApi";
import { IUserModel } from "../../../types/types";
import { IUser } from "../../repsaApi";

let currentRequest: AbortController | null = null;

export function getUser(cancelToken?: CancelToken) {
  return function (dispatch: any) {
    if (currentRequest) {
      currentRequest.abort();
    }

    currentRequest = new AbortController();

    dispatch(userLoading());
    apiUser
      .getUser(cancelToken)
      .then(
        (data: IUser) => {
          dispatch(userLoaded(data));
          currentRequest = null;
        },
        function (error: any) {
          if (!axios.isCancel(error)) {
            console.error(error);
            dispatch(userLoadingError());
          }
          currentRequest = null;
        }
      )
      .catch((error: any) => {
        if (!axios.isCancel(error) && error.name !== "AbortError") {
          console.error("Error in catch", error);
          dispatch(userLoadingError());
        }
        currentRequest = null;
      });
  };
}
